<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <!--                        <button v-if='$gate.isMISAdmin()' type="button" class="btn btn-tool btn-secondary" @click="syncLeadStatus"><i class="fa fa-refresh"></i> Sync</button>-->
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.from_date"
                                            placeholder="From date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.to_date"
                                            placeholder="To date"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Product:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="params.product"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >EntryPoint:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.entry_point"
                                        >
                                            <option value="POS">POS</option>
                                            <option value="CARE">CARE</option>
                                            <option value="CRM">CRM</option>
                                            <option value="ECOMMERCE">
                                                ECOMMERCE
                                            </option>
                                            <option value="ONLINE">
                                                ONLINE
                                            </option>
                                            <option value="WACHATBOT">
                                                WHATSAPP CHATBOT
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Campaign Media:</span
                                        >
                                        <v-select
                                            v-model="params.campaign_media"
                                            :options="medias"
                                            label="name"
                                            :reduce="(medias) => medias.id"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Lead Status:</span
                                        >
                                        <select
                                            v-model="params.summary"
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="0">Pending</option>
                                            <option value="1">
                                                Gatepass Created
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Similar Leads:</span
                                        >
                                        <select
                                            v-model="params.similar_leads"
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="0">Show all</option>
                                            <option value="1">
                                                Show matching leads only
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Assignment Status:</span
                                        >
                                        <select
                                            v-model="params.assignment"
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="0">
                                                Un-assigned
                                            </option>
                                            <option value="1">Assigned</option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Lead ID:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="params.id"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Location:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="params.location"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Requirement:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="params.requirement"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Gatepass ID:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="params.gatepass_id"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Results per Page:</span
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="params.results"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-sm-4"
                                    v-if="
                                        $gate.isZonalManager() ||
                                        $gate.isMISAdmin() ||
                                        $gate.isMarketingAdmin() ||
                                        $gate.isMarketingManager() ||
                                        $gate.isSecondaryMISAdmin() ||
                                        $gate.isCCManager() ||
                                        $gate.isCCAgent() ||
                                        $gate.isOnlineSalesManager() ||
                                        $gate.isOnlineSalesAssociate()
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <v-select
                                            v-model="params.branch"
                                            class="form-control"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            name="branch"
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Phone Number:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a phone number"
                                            v-model="params.phone_number"
                                            type="number"
                                            min="1000000000"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Lead Name:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a lead name"
                                            v-model="params.name"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created By:</span
                                        >
                                        <v-select
                                            v-model="params.created_by"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Assigned To:</span
                                        >
                                        <v-select
                                            v-model="params.assigned_to"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="
                                                getLeadSheetItems(
                                                    '/api/getLeadSheetItems'
                                                )
                                            "
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>

                                <!--                            <div class="col-sm-4" v-if="params.from_date!=null && params.to_date!=null ">-->
                                <!--                                <div class="form-group" v-if="$gate.isMISAdmin()||$gate.isCCManager()">-->
                                <!--                                    <button class="btn btn-success" style="width:100% !important;" @click="exportGatepasses">Export</button>-->
                                <!--                                </div>-->
                                <!--                            </div>-->
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-md-9">
                        DATASHEET V1.4 &nbsp;<button
                            class="btn btn-secondary"
                            @click="getLeadSheetItems()"
                        >
                            <i class="fa fa-refresh"></i> Refresh
                        </button>
                        <br />
                        <br />
                        <div class="col-md-12">
                            <div class="row" align="center">
                                <div class="col-lg-3 col-12">
                                    <!-- small box -->
                                    <div class="small-box bg-danger">
                                        <div class="inner">
                                            <h4>{{ total_results }}</h4>
                                            <p>Total Entries</p>
                                        </div>
                                        <div class="icon">
                                            <i class="ion ion-person-add"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-12">
                                    <!-- small box -->
                                    <div class="small-box bg-danger">
                                        <div class="inner">
                                            <h4>{{ gatepassed }}</h4>
                                            <p>Reached</p>
                                        </div>
                                        <div class="icon">
                                            <i class="ion ion-person-add"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-12">
                                    <!-- small box -->
                                    <div class="small-box bg-secondary">
                                        <div class="inner">
                                            <h4>{{ reached_out }}</h4>
                                            <p>Unique Reached</p>
                                        </div>
                                        <div class="icon">
                                            <i class="ion ion-person-add"></i>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="col-lg-3 col-12"
                                    v-if="
                                        $gate.isMISAdmin() ||
                                        $gate.isCCManager()
                                    "
                                >
                                    <!-- small box -->
                                    <div class="small-box bg-secondary">
                                        <div class="inner">
                                            <h4>{{ selectedIdsCount }}</h4>
                                            <p>Leads Selected</p>
                                        </div>
                                        <div class="icon">
                                            <i class="ion ion-check"></i>
                                        </div>
                                    </div>
                                </div>

                                <!--                          <div class="col-lg-3 col-12">-->
                                <!--                              &lt;!&ndash; small box &ndash;&gt;-->
                                <!--                              <div class="small-box bg-danger">-->
                                <!--                                  <div class="inner">-->
                                <!--                                      <h4>{{opportunities | dotNumbers}}</h4>-->
                                <!--                                      <p>New/Opportunities</p>-->
                                <!--                                  </div>-->
                                <!--                                  <div class="icon">-->
                                <!--                                      <i class="ion ion-pie-graph"></i>-->
                                <!--                                  </div>-->
                                <!--                              </div>-->
                                <!--                          </div>-->

                                <!--                          <div class="col-lg-3 col-12">-->
                                <!--                              &lt;!&ndash; small box &ndash;&gt;-->
                                <!--                              <div class="small-box bg-orange">-->
                                <!--                                  <div class="inner">-->
                                <!--                                      <h4>{{converted | dotNumbers}}</h4>-->
                                <!--                                      <p>Converted</p>-->
                                <!--                                  </div>-->
                                <!--                                  <div class="icon">-->
                                <!--                                      <i class="ion ion-bag"></i>-->
                                <!--                                  </div>-->
                                <!--                              </div>-->
                                <!--                          </div>-->

                                <!--                          <div class="col-lg-3 col-12">-->
                                <!--                              &lt;!&ndash; small box &ndash;&gt;-->
                                <!--                              <div class="small-box bg-success">-->
                                <!--                                  <div class="inner">-->
                                <!--                                      <h4>{{lost | dotNumbers}}</h4>-->
                                <!--                                      <p>Lost</p>-->
                                <!--                                  </div>-->
                                <!--                                  <div class="icon">-->
                                <!--                                      <i class="ion ion-bin"></i>-->
                                <!--                                  </div>-->
                                <!--                              </div>-->
                                <!--                          </div>-->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <pagination
                            :pagination="pagination"
                            @prev="getLeadSheetItems(pagination.prevPageUrl)"
                            @next="getLeadSheetItems(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
                <br />
                <br />
                <div
                    class="row"
                    v-if="
                        $gate.isMISAdmin() ||
                        $gate.isCCManager() ||
                        $gate.isBranchManager()
                    "
                >
                    <div class="col-lg-12 overflow-auto">
                        BULK ASSIGNER WIZARD V1.0<br />
                        <!--            <div class="card card-secondary card-outline">-->
                        <!--                <div class="card-header">-->
                        <!--                    <div class="card-title">Bulk Assignment Wizard</div>-->
                        <!--                    <div class="card-tools">-->
                        <!--                         Collapse Button -->
                        <!--                        <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>-->
                        <!--                    </div>-->
                        <!--                </div>-->
                        <!--                <div class="card-body">-->
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <!--                            <div class="col-sm-4">-->
                                <!--                                <div class="form-group">-->
                                <!--                                    <span class="right badge badge-secondary">EntryPoint:</span>-->
                                <!--                                    <select class="form-control" v-model="params.entry_point">-->
                                <!--                                        <option value="POS">POS</option>-->
                                <!--                                        <option value="CARE">CARE</option>-->
                                <!--                                        <option value="CRM">CRM</option>-->
                                <!--                                        <option value="ECOMMERCE">ECOMMERCE</option>-->
                                <!--                                        <option value="ONLINE">ONLINE</option>-->
                                <!--                                        <option value="WACHATBOT">WHATSAPP CHATBOT</option>-->
                                <!--                                    </select>-->
                                <!--                                </div>-->
                                <!--                            </div>-->
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Campaign Media:</span
                                        >
                                        <v-select
                                            v-model="selection.campaign_media"
                                            :options="medias"
                                            label="name"
                                            :reduce="(medias) => medias.id"
                                        ></v-select>
                                    </div>
                                </div>

                                <div
                                    class="col-sm-3"
                                    v-if="
                                        $gate.isZonalManager() ||
                                        $gate.isMISAdmin() ||
                                        $gate.isSecondaryMISAdmin() ||
                                        $gate.isCCManager() ||
                                        $gate.isCCAgent() ||
                                        $gate.isOnlineSalesManager() ||
                                        $gate.isOnlineSalesAssociate()
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <v-select
                                            v-model="selection.branch"
                                            class="form-control"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            name="branch"
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Assigned To:</span
                                        >
                                        <v-select
                                            v-model="selection.assigned_to"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Gatepass Type:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="selection.activity"
                                        >
                                            <option value="Sales">Sales</option>
                                            <option value="Service">
                                                Service
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="
                                                bulkUpdateLeadSheet(
                                                    '/api/bulkUpdateLeadSheet'
                                                )
                                            "
                                        >
                                            Bulk-Assign
                                        </button>
                                    </div>
                                </div>

                                <div
                                    class="col-sm-4"
                                    v-if="
                                        params.from_date != null &&
                                        params.to_date != null
                                    "
                                >
                                    <div
                                        class="form-group"
                                        v-if="
                                            $gate.isMISAdmin() ||
                                            $gate.isCCManager()
                                        "
                                    >
                                        <button
                                            class="btn btn-secondary"
                                            style="width: 100% !important"
                                            @click="
                                                bulkGatepassConversion(
                                                    '/api/bulkGatepassConversion'
                                                )
                                            "
                                        >
                                            QuickPass
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-info"
                                            style="width: 100% !important"
                                            @click="clearSelection"
                                        >
                                            Clear Selection
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th
                                        v-if="
                                            $gate.isMISAdmin() ||
                                            $gate.isCCManager()
                                        "
                                        scope="col"
                                        style="width: 2%"
                                    >
                                        <input
                                            type="checkbox"
                                            v-model="selectAll"
                                            @change="selectAllItems"
                                        />
                                    </th>
                                    <th scope="col" style="width: 10%">
                                        Date & Branch
                                    </th>
                                    <th scope="col" style="width: 20%">
                                        Lead Particulars
                                    </th>
                                    <th scope="col" style="width: 9%">
                                        Location
                                    </th>
                                    <th scope="col" style="width: 14%">
                                        Requirement
                                    </th>
                                    <th scope="col" style="width: 10%">
                                        Campaign
                                    </th>
                                    <th scope="col" style="width: 10%">
                                        Assigned To
                                    </th>
                                    <th scope="col" style="width: 10%">
                                        Gatepass
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="j in leads">
                                    <td
                                        v-if="
                                            $gate.isMISAdmin() ||
                                            $gate.isCCManager() ||
                                            $gate.isBranchManager()
                                        "
                                    >
                                        <input
                                            type="checkbox"
                                            v-model="selectedIds"
                                            :value="j.id"
                                        />
                                    </td>
                                    <td>
                                        <h4>{{ j.branch_code }}</h4>
                                        <p>{{ j.created_at | timeStamp }}</p>
                                    </td>
                                    <td>
                                        <h5>
                                            <span
                                                class="right badge badge-primary"
                                                >{{ j.id }}&nbsp;</span
                                            >
                                            <span
                                                v-if="j.entry_point == 'CRM'"
                                                class="right badge badge-warning"
                                                >{{ j.entry_point }}&nbsp;</span
                                            >
                                            <span
                                                v-if="j.entry_point == 'CARE'"
                                                class="right badge badge-info"
                                                >{{ j.entry_point }}&nbsp;</span
                                            >
                                            <span
                                                v-if="j.entry_point == 'POS'"
                                                class="right badge badge-danger"
                                                >{{ j.entry_point }}&nbsp;</span
                                            >
                                            <span
                                                v-if="j.entry_point == 'ONLINE'"
                                                class="right badge badge-primary"
                                                >{{ j.entry_point }}&nbsp;</span
                                            >
                                            <span
                                                v-if="
                                                    j.entry_point == 'ECOMMERCE'
                                                "
                                                class="right badge badge-primary"
                                                >{{ j.entry_point }}&nbsp;</span
                                            >
                                            <span
                                                v-if="
                                                    j.entry_point == 'WACHATBOT'
                                                "
                                                class="right badge badge-success"
                                                >{{ j.entry_point }}&nbsp;</span
                                            >
                                        </h5>
                                        <p>{{ j.full_name }}</p>
                                        <h5 v-if="j.gatepass != null">
                                            <span
                                                v-if="
                                                    j.gatepass.status !=
                                                        'Converted' &&
                                                    j.gatepass.status != 'Lost'
                                                "
                                                class="right badge badge-secondary"
                                                >{{
                                                    j.gatepass.status
                                                }}&nbsp;</span
                                            >
                                            <span
                                                v-if="
                                                    j.gatepass.status ==
                                                    'Converted'
                                                "
                                                class="right badge badge-success"
                                                >{{
                                                    j.gatepass.status
                                                }}&nbsp;</span
                                            >
                                            <span
                                                v-if="
                                                    j.gatepass.status == 'Lost'
                                                "
                                                class="right badge badge-danger"
                                                >{{
                                                    j.gatepass.status
                                                }}&nbsp;</span
                                            >
                                        </h5>
                                    </td>
                                    <td>
                                        <p>
                                            {{ j.city }}&nbsp;{{ j.district }}
                                        </p>
                                    </td>
                                    <td>
                                        <p>{{ j.requirement }}</p>
                                        <p>
                                            <span
                                                class="right badge badge-info"
                                                >{{ j.product }}</span
                                            >
                                        </p>
                                        <p>{{ j.custom_data_points }}</p>
                                    </td>
                                    <td v-if="j.campaign_media != null">
                                        <p>{{ j.campaign_media.name }}</p>
                                    </td>
                                    <td v-else><p>N/A</p></td>
                                    <td
                                        v-if="
                                            j.assigned_to != '' &&
                                            j.assigned_to != null
                                        "
                                    >
                                        <p>
                                            {{ j.assigned_to.first_name }}
                                            {{ j.assigned_to.last_name }}
                                        </p>
                                        <!--                        <p>{{ j.assigned_to.email }}</p>-->
                                        <p>{{ j.assigned_to.phone }}</p>
                                    </td>
                                    <td
                                        v-if="
                                            j.assigned_to == '' ||
                                            j.assigned_to == null
                                        "
                                    >
                                        Unassigned
                                    </td>
                                    <td>
                                        <button
                                            v-if="j.gatepass_id != null"
                                            class="btn btn-secondary"
                                            style="width: 100%"
                                            @click="viewGatepass(j)"
                                        >
                                            View
                                        </button>
                                        <button
                                            v-if="j.gatepass_id == null"
                                            class="btn btn-danger"
                                            style="width: 100%"
                                            @click="createGatepass(j.id)"
                                        >
                                            Create
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getLeadSheetItems(pagination.prevPageUrl)"
                            @next="getLeadSheetItems(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="reassignmodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Modal title</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Branch:</label>
                            <v-select
                                v-model="branch"
                                :options="branches"
                                :reduce="(branches) => branches.branch_code"
                                placeholder="Select destination branch"
                                label="fullname"
                                @input="getSalesmen"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label>Assign To:</label>
                            <v-select
                                v-model="salesman"
                                :options="salesmen"
                                label="user_detail"
                                :reduce="(salesmen) => salesmen.id"
                            ></v-select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="reAssign"
                        >
                            Re Assign
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="statusmodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change Status</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Status:</label>
                            <v-select
                                v-model="gpstatus"
                                :options="gpstatuses"
                                label="status"
                                :reduce="(gpstatuses) => gpstatuses.status"
                            ></v-select>
                        </div>
                        <div class="form-group" v-if="gpstatus == 'Lost'">
                            <label>Turnaway Reason: </label>
                            <v-select
                                v-model="turnaway_reason"
                                type="text"
                                label="name"
                                :options="reasons"
                                :reduce="(reasons) => reasons.name"
                                placeholder="Select Reason"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label>Notes</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Enter the notes"
                                v-model="notes"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="changeStatus"
                        >
                            Change
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="viewmodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Gatepass</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ gatepass }}
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>

        <loading :show="lshow" :label="llabel"> </loading>
    </div>

    <!-- All VUE Parts end before this comment -->
    <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
</template>

<script>
import { parse } from "postcss";
import Pagination from "../../pagination.vue";
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { loading: loading, pagination: Pagination },

    created() {
        this.params.type = "Sales";
        this.getLeadSheetItems();
        this.getCampaignMedias();
        this.getBranches();
        this.getSalesmen();
        this.getLinkages();
        this.getProducts();
        this.getGPStatuses();
        this.getReasons();
        this.pollData();
    },

    data() {
        return {
            leads: [],
            reached_out: "-",
            gatepassed: "-",
            selected_leads: [],
            medias: [],
            lshow: false,
            llabel: "Updating Leads. Do not close or change this page...",
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            gpstatuses: [],
            total_results: "-",
            opportunities: "...",
            lost: "...",
            converted: "...",
            gpstatus: "",
            salesmen: [],
            linkages: [],
            products: [],
            salesman: "",
            branch: "",
            branches: [],
            turnaway_reason: "",
            reasons: [],
            gp_id: "",
            gatepass: {},
            notes: "",
            interval: "",
            params: new Form({
                status: "",
                from_date: "",
                to_date: "",
                name: "",
                type: "",
                similar_leads: "",
                assignment: "",
                campaign_media: "",
                product: "",
                entry_point: "",
                phone_number: "",
                item_category: "",
                branch: "",
                location: "",
                requirement: "",
                summary: "",
                results: "55",
                created_by: "",
                assigned_to: "",
                id: "",
                gatepass_id: "",
            }),
            selection: new Form({
                campaign_media: "",
                branch: "",
                activity: "",
                created_by: "",
                assigned_to: "",
                status: "",
                product: "",
                entry_point: "",
            }),
            selectedIds: [],
            selectAll: false,
        };
    },

    computed: {
        selectedIdsCount() {
            return this.selectedIds.length;
        },
    },

    methods: {
        // getSalesmen() {
        //     axios.post("/api/getBranchUsers", {branch: this.branch})
        //         .then((response) => {
        //             this.salesmen = response.data;
        //         });
        // },
        pollData() {
            this.interval = setInterval(() => {
                this.getLeadSheetItems(
                    "/api/getLeadSheetItems" +
                        "?page=" +
                        this.pagination.currentPage
                );
            }, 20000);
        },
        getSalesmen() {
            axios.post("/api/getBranchCallAgents").then((response) => {
                this.salesmen = response.data;
            });
        },
        selectAllItems() {
            if (this.selectAll) {
                this.selectedIds = this.leads.map((j) => j.id);
            } else {
                this.selectedIds = [];
            }
        },
        syncLeadStatus() {
            this.lshow = true;
            axios.post("/api/findAndUpdateAttemptedLeads").then((response) => {
                this.lshow = false;
                toast.fire({
                    icon: "success",
                    title: "Leads and Gatepasses Synced",
                });
                console.log(response.data);
            });
        },

        bulkUpdateLeadSheet(url = "/api/bulkUpdateLeadSheet") {
            this.lshow = true;
            axios
                .post(url, {
                    filters: this.selection,
                    selection: this.selectedIds,
                })
                .then((response) => {
                    this.getLeadSheetItems(
                        "/api/getLeadSheetItems" +
                            "?page=" +
                            this.pagination.currentPage
                    );
                    console.log(response.data);
                    this.lshow = false;
                    toast.fire({
                        icon: "success",
                        title: "Leads assigned.",
                    });
                });
        },

        bulkGatepassConversion(url = "/api/bulkGatepassConversion") {
            this.lshow = true;
            axios
                .post(url, {
                    filters: this.selection,
                    selection: this.selectedIds,
                })
                .then((response) => {
                    this.getLeadSheetItems(
                        "/api/getLeadSheetItems" +
                            "?page=" +
                            this.pagination.currentPage
                    );
                    console.log(response.data);
                    this.lshow = false;
                    toast.fire({
                        icon: "success",
                        title: "Quickpass Generation Complete.",
                    });
                })
                .catch(() => {
                    this.lshow = false;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        getCampaignMedias() {
            axios.post("/api/getCampaignMedias").then((response) => {
                this.medias = response.data;
            });
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getLinkages(url = "/api/getActiveCategoryProductLinks") {
            axios.post(url).then((response) => {
                this.linkages = response.data.data;
            });
        },

        getProducts(url = "/api/getMasterProductList") {
            axios.post(url).then((response) => {
                this.products = response.data;
            });
        },

        getGPStatuses() {
            axios.post("/api/getGPStatuses").then((response) => {
                this.gpstatuses = response.data;
            });
        },

        reset() {
            this.params.reset();
            this.getLeadSheetItems();
        },

        clearSelection() {
            this.selection.reset();
            this.selectedIds = [];
        },

        getLeadSheetItems(url = "/api/getLeadSheetItems") {
            axios.post(url, { filters: this.params }).then((response) => {
                this.leads = response.data.data.data;
                this.configPagination(response.data.data);
                this.total_results = response.data.data.total;
                this.reached_out = response.data.reached_out;
                this.gatepassed = response.data.gatepassed;
            });
        },

        getReasons() {
            axios.post("/api/getAllTAR").then((response) => {
                this.reasons = response.data;
            });
        },

        viewGatepass(lead) {
            // this.$router.push('/gatepass/gatepass-details/'+gatepass.id);
            window.open(
                "/gatepass/gatepass-details/" + lead.gatepass_id,
                "_blank"
            );
        },
        createGatepass(lead_id) {
            window.open("/sales/new-gatepass/" + lead_id, "_blank");
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        reAssignPrompt(id) {
            this.gp_id = id;
            $("#reassignmodal").modal("show");
        },

        reAssign() {
            axios
                .post("/api/gatepassReAssign", {
                    gatepass: this.gp_id,
                    salesman: this.salesman,
                    branch: this.branch,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Re Assigned",
                    });
                    this.getLeadSheetItems();
                    $("#reassignmodal").modal("hide");
                });
        },

        statusPrompt(id) {
            this.gp_id = id;
            $("#statusmodal").modal("show");
        },

        exportGatepasses() {
            axios({
                url: "/api/getLeadSheetItemsExport",
                data: {
                    results: this.results,
                    params: this.params,
                },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Report Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(response.data, "O2CRM_Gatepasses.xlsx");
            });
        },

        changeStatus() {
            axios
                .post("/api/changeGatepassStatus", {
                    gatepass: this.gp_id,
                    status: this.gpstatus,
                    turnaway_reason: this.turnaway_reason,
                    notes: this.notes,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Status Changed",
                    });
                    this.getLeadSheetItems();
                    $("#statusmodal").modal("hide");
                });
        },
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
};
</script>
